var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"contacts"},[_c('v-data-table',{staticClass:"elevation-1 pa-2",attrs:{"headers":_vm.headers_Contacts,"items":_vm.responseData.contactList,"items-per-page":10,"hide-default-footer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }